import { EntityAcl, EntityContext } from '@msdk/definitions'
import { useRecoilState_TRANSITION_SUPPORT_UNSTABLE } from 'recoil'

import { $entityCollection, CollectionEntry } from './atoms'

export function useEntryFromCollection(entityId: string): CollectionEntry {
  const [entityCollection] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE($entityCollection)
  const key = Object.keys(entityCollection).find((k) => entityCollection[k].entity.id === entityId)
  return entityCollection[key as string]
}

export function useEntryFromCollectionWithInternalId(internalId: string): CollectionEntry {
  const [entityCollection] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE($entityCollection)
  return entityCollection[internalId]
}

export function useEntityFromCollection(entityId: string): EntityContext | null {
  const entityCollection = useEntryFromCollection(entityId)
  if (entityCollection && entityCollection.entity) {
    const entityContext = new EntityContext(
      entityCollection.entity,
      entityCollection.rootNode,
      entityCollection.additionalEntities,
    )
    return entityContext
  }
  return null
}

export function useAclFromCollection(entityId: string): EntityAcl {
  const entry = useEntryFromCollection(entityId)
  return entry.acl
}
